/**
 * Notification Management Page
 *
 * Purpose: Admin page for managing notifications
 */

export function NotificationsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-800">Notification Management</h1>
        <p className="mt-2 text-gray-600">Manage application notifications</p>
      </div>

      <div className="bg-white rounded-lg border border-gray-300 p-6">
        <p className="text-gray-600">
          Send push notifications or open the notification list from the sidebar.
        </p>
      </div>
    </div>
  )
}

